<script>
  import { onMount } from "svelte";
  import { supabase } from "./supabaseClient";

  let memberCount = 0;
  let memberText = "";
  /**
   * DBから現在チャットに参加中のユーザー一覧を取得して画面に表示
   */
  export const viewCurrentMember = async () => {
    try {
      let { data, error } = await supabase
        .from("current_member")
        .select(`member_id, member(name)`)
        .eq("removed", "false");
      if (error) throw error;

      const currentMembers = data;
      memberCount = currentMembers.length;
      memberText = currentMembers
        .map((currentMember) => {
          return currentMember.member.name;
        })
        .join("、");
      return true;
    } catch (error) {}
  };

  onMount(async () => {
    viewCurrentMember();
  });
</script>

<div class="member">
  <label for="">参加者({memberCount})：</label>
  <span>{memberText}</span>
  <hr />
</div>

<style>
  .member {
    padding: 5px 10px;
  }
</style>
